import { getGroup } from "@/assets/utils/unit";
export const timeNumberList = [
  "单次",
  "不限次",
  "2次",
  "3次",
  "4次",
  "5次",
  "6次",
  "7次",
  "8次",
  "9次",
];
export const timeNumberList1 = [
  "单日票",
  "2日票",
  "3日票",
  "4日票",
  "5日票",
  "6日票",
  "周票",
  "月票",
  "年票",
  "半日票",
  "时段票",
];
export const dateMs = {
  1: [],
  2: [],
  3: [],
  4: [],
  5: [],
  6: [],
  7: [],
  8: [],
  9: [],
  10: [],
  11: [],
  12: [],
};

export const trafficCost = [
  {
    title: "报价包含公里",
    placeholder: "请点击输入公里数描述。举例：以行程为准",
    code: "lncludingKm", //渲染的字段
  },
  {
    title: "单日公里上限",
    placeholder: "举例：每日公里数不可超过350公里",
    code: "oneDayKm", //渲染的字段
  },
  {
    title: "额外公里收费标准",
    placeholder: "举例：超公里5人民币/公里",
    code: "additionalKm", //渲染的字段
  },
  {
    title: "加班单价/小时",
    placeholder: "举例：50人民币/小时",
    code: "workPrice", //渲染的字段
  },
  {
    title: "单日工作时间上限",
    placeholder: "举例：每日10小时",
    code: "oneDayWork", //渲染的字段
  },
];
export const trafficCost1 = [
  {
    title: "停车费",
    placeholder: "若不含，请点击输入预计费用",
    code: "parkingDescription", //渲染的字段
    text: ["含", "不含"],
    code1: "parking",
  },
  {
    title: "高速费",
    placeholder: "若不含，请点击输入预计费用",
    code: "highSpeedDescription", //渲染的字段
    text: ["含", "不含"],
    code1: "highSpeed",
  },
  {
    title: "路/桥费",
    placeholder: "若不含，请点击输入预计费用",
    code: "roadAndBridgeDescription", //渲染的字段
    text: ["含", "不含"],
    code1: "roadAndBridge",
  },
  {
    title: "进城费",
    placeholder: "若不含，请点击输入预计费用",
    code: "townDescription", //渲染的字段
    text: ["含", "不含"],
    code1: "town",
  },
  {
    title: "轮渡费",
    placeholder: "若不含，请点击输入预计费用",
    code: "ferryDescription", //渲染的字段
    text: ["含", "不含"],
    code1: "ferry",
  },
  {
    title: "司机小费",
    placeholder: "若不含，请点击输入预计费用",
    code: "driverDescription", //渲染的字段
    text: ["含", "不含"],
    code1: "driver",
  },
  {
    title: "司机餐补",
    placeholder: "若不含，请点击输入预计费用",
    code: "mealTonicDescription", //渲染的字段
    text: ["含", "不含"],
    code1: "mealTonic",
  },
  {
    title: "司机住补",
    placeholder: "若不含，请点击输入预计费用",
    code: "housingSubsidyDescription", //渲染的字段
    text: ["含", "不含"],
    code1: "housingSubsidy",
  },
];
export const trafficCost3 = [
  {
    title: "小费",
    placeholder: "若需要，请点击输入预计费用",
    code: "", //渲染的字段
    text: ["无需", "需要"],
  },
  {
    title: "餐补",
    placeholder: "若需要，请点击输入预计费用",
    code: "", //渲染的字段
    text: ["无需", "需要"],
  },
  {
    title: "住补",
    placeholder: "若需要，请点击输入预计费用",
    code: "", //渲染的字段
    text: ["无需", "需要"],
  },
  {
    title: "交通补",
    placeholder: "若需要，请点击输入预计费用",
    code: "", //渲染的字段
    text: ["无需", "需要"],
  },
  {
    title: "其它",
    placeholder: "若需要，请点击输入预计费用",
    code: "", //渲染的字段
    text: ["无需", "需要"],
  },
  {
    title: "司机住补",
    placeholder: "若不含，请点击输入预计费用",
    code: "", //渲染的字段
    text: ["无需", "需要"],
  },
];
export const trafficCost4 = [
  {
    title: "单日工作时间上限",
    placeholder: "举例：每日10小时",
    code: "", //渲染的字段
  },
  {
    title: "加班单价/小时",
    placeholder: "举例：50人民币/小时",
    code: "", //渲染的字段
  },
];
export const costObj = {
  3: trafficCost,
  5: trafficCost,
  9: trafficCost4,
};
export const costObj1 = {
  3: trafficCost1,
  5: trafficCost1,
  9: trafficCost3,
};
//获取当前年份
export function doHandleYear() {
  let myDate = new Date();
  let result = myDate.getFullYear();
  return result;
}
//获取当前年 并且往后推后俩年
export function yearDataList(year = 2023, lastYear = 2, that) {
  let arr = [];
  arr[0] = [year];
  for (let i = 0; i < lastYear; i++) {
    let ye = year + i + 1;
    arr.push(String(ye));
  }
  let result = {};
  arr.forEach((item) => {
    that.$set(result, item, JSON.parse(JSON.stringify(dateMs)));
  });
  console.log(JSON.stringify(result), "看看转换后的数据");
  return result;
}
export function dateArrs(obj, year) {
  let result = [];
  for (const keys in obj[year]) {
    result = [...result, ...obj[year][keys]];
  }
  return result;
}
//获取当前年月日
export function presentDate(yearNum = 0) {
  let result = [];
  let date = new Date();
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  month = month > 9 ? month : "0" + month;
  day = day < 10 ? "0" + day : day;
  let startDate = year + "-" + month + "-" + day;
  let endDate = +year + yearNum + "-" + 12 + "-" + 31;
  result = [startDate, endDate];
  return result;
}
//时段选择内容
export const timeFrame = [
  {
    time: "全天9:00-19:00",
    type: 0,
  },
  {
    time: "上午9:00-12:00",
    type: 1,
  },
  {
    time: "下午14:00-19:00",
    type: 2,
  },
  {
    time: "晚上17:00-22:00",
    type: 3,
  },
  // {
  //   time: "自定义",
  //   type: 4,
  // },
];
export const timeFrame1 = {
  0: {
    time: "9:00～19:00",
    type: "全天",
  },
  1: {
    time: "9:00～12:00",
    type: "上午",
  },
  2: {
    time: "14:00～19:00",
    type: "下午",
  },
  3: {
    time: "17:00～22:00",
    type: "晚上",
  },
  4: {
    time: null,
    type: "自定义",
  },
};
export const useTimeList = {
  0: "晚",
  // 1: 't',
  2: "次",
  // 3: "辆",
  // 4: "顿",
  5: "人",
  6: "次",
  // 7: '次',
  8: "次",
  9: "次",
};
export const priceUnit = {
  0: ["间", "人"],
  1: ["间", "人"],
  2: ["团", "人"],
  3: ["天","辆", "人"],
  4: ["人", "桌", "团"],
  5: ["人", "团"],
  6: ["人", "团"],
  7: ["人", "团"],
  8: ["团", "人"],
  9: ["人", "团"],
};
//包含的设施与服务
export const contains = [
  {
    containDescribe: "",
    currency: "¥",
    id: null,
    name: "",
    number: null,
    price: null,
    stockId: null,
    type: 2,
  },
  {
    containDescribe: "",
    currency: "¥",
    id: null,
    name: "",
    number: null,
    price: null,
    stockId: null,
    type: 1,
  },
  {
    containDescribe: "",
    currency: "¥",
    id: null,
    name: "",
    number: null,
    price: null,
    stockId: null,
    type: 4,
  },
  {
    containDescribe: "",
    currency: "¥",
    id: null,
    name: "",
    number: null,
    price: null,
    stockId: null,
    type: 3,
  },
];
//退改政策
export const cancelPolicyList = {
  3: [
    {
      cancelData: "",
      cancelProportion: null,
      cancelTime: "",
      day: null,
      id: null,
      stockId: null,
    },
  ],
  4: [
    {
      cancelData: "",
      cancelProportion: null,
      cancelTime: "",
      day: null,
      id: null,
      stockId: null,
    },
  ],
};

export const otherStockDatas = {
  0: {
    breakfastNum: null,
    breakfastRemark: null,
  },
  1: {},
  2: {
    ticketSpeed: null,
    applicability: null,
    purchaseRestriction: null,
    ticketContactInfo: "",
    appointment: null,
    appointmentMethod: "",
    ticketMethod: null,
    ticketInfo: "",
    ticketTime: null,
    address: "",
    users: null,
    joinTime: "",
  },
  3: {
    vehicleStandard: "",
    productCategoryId: null,
    driverStandard: "",
    lncludingKm: null,
    additionalKm: null,
    oneDayKm: null,
    workPrice: null,
    oneDayWork: null,
    parking: null,
    parkingDescription: null,
    driver: null,
    driverDescription: null,
    highSpeed: null,
    highSpeedDescription: null,
    mealTonic: null,
    mealTonicDescription: null,
    roadAndBridge: null,
    roadAndBridgeDescription: null,
    housingSubsidy: null,
    housingSubsidyDescription: null,
    town: null,
    townDescription: null,
    ferry: null,
    ferryDescription: null,
    busName: null,
    busId: null,
    contactName: null,
    contactId: null,
    emergencyContactName: null,
    emergencyContactNameId: null,
  },
  5: {
    vehicleStandard: "",
    productCategoryId: null,
    driverStandard: "",
    lncludingKm: null,
    additionalKm: null,
    oneDayKm: null,
    workPrice: null,
    oneDayWork: null,
    parking: null,
    parkingDescription: null,
    driver: null,
    driverDescription: null,
    highSpeed: null,
    highSpeedDescription: null,
    mealTonic: null,
    mealTonicDescription: null,
    roadAndBridge: null,
    roadAndBridgeDescription: null,
    housingSubsidy: null,
    housingSubsidyDescription: null,
    town: null,
    townDescription: null,
    ferry: null,
    ferryDescription: null,
    busName: null,
    busId: null,
    contactName: null,
    contactId: null,
    emergencyContactName: null,
    emergencyContactNameId: null,
  },
  6: {
    acceptanceCrowd: [],
    populationList: [],
    collarAreaAll: false,
    collarAreaList: [],
    isInterview: null,
    isMake: null,
    isFingerprint: null,
    isCos: null,
    visaMakeDate: null,
    embassyNeedDate: null,
    phone: null,
    useTime: null,
    visaEffective: null,
    stayMax: null,
    isShowFile: null,
    specialReminder: null,
    attention: null,
  },
};
//基础产品的参数
export const commdityDatas = {
  templateId: 0,
  cancelExplain: "",
  cancelPolicyList: [],
  contains: [],
  cancelTime: "",
  cancelType: 1,
  cityId: null,
  cityTaxPrice: null,
  costExplain: "",
  createCompanyId: null,
  createCompanyName: "",
  createId: null,
  createName: "",
  createTime: "",
  delay: null,
  id: null,
  inquiryId: null,
  invoiceExplain: "",
  isCityTax: null,
  isSplit: null,
  isVat: null,
  optionTime: "",
  optionTimeExplain: "",
  otherExplain: "",
  planId: null,
  otherStockData: {
    modelStandard: "",
    driverStandard: "",
  },
  prices: [
    {
      cherish: "",
      combinationId: null,
      currency: "¥",
      days: "",
      id: null,
      month: "",
      priceCompany: "",
      priceUnit: "间",
      remark: "",
      restrictionsDescribe: "",
      saleNumber: null,
      salePrice: null,
      staffPrice: null,
      stockId: "",
      stockNumber: null,
      stockPrice: null,
      storePrice: null,
      timeType: null,
      timeTypeRemark: "",
      toBPrice: null,
      useTime: "",
      year: "",
      otherObject: {
        id: null,
        stockId: null,
        stockPriceId: null,
        peopleNum: null,
        numSelection: "团队票",
        ticketType: "单日票",
        restricts: "可入内次数",
        behavior: "单次",
        startOpen: "",
        endOpen: "",
        limitTime: "00.00",
      },
    },
  ],
  productId: 0,
  productNameCn: "",
  productNameEn: "",
  recommendation: "",
  resourceId: 0,
  resourceNameCn: "",
  resourceNameEn: "",
  saleOptionTime: "",
  securityExplain: "",
  state: null,
  status: 1,
  stockType: 2,
  useExplain: "",
  useMethod: "",
  vatPrice: null,
};
export const otherObject = {
  2: {
    id: null,
    stockId: null,
    stockPriceId: null,
    peopleNum: null,
    numSelection: "团队票",
    ticketType: "单日票",
    restricts: "可入内次数",
    behavior: "单次",
    startOpen: "",
    endOpen: "",
    limitTime: "00.00",
  },
};
export const prices = {
  cherish: "",
  combinationId: null,
  currency: "¥",
  days: "",
  id: null,
  month: "",
  priceCompany: "",
  priceUnit: "间",
  remark: "",
  restrictionsDescribe: "",
  saleNumber: null,
  salePrice: null,
  staffPrice: null,
  stockId: "",
  stockNumber: null,
  stockPrice: null,
  storePrice: null,
  timeType: null,
  timeTypeRemark: "",
  toBPrice: null,
  useTime: "",
  year: "",
  otherObject: {
    id: null,
    stockId: null,
    stockPriceId: null,
    peopleNum: null,
    numSelection: "团队票",
    ticketType: "单日票",
    restricts: "可入内次数",
    behavior: "单次",
    startOpen: "",
    endOpen: "",
    limitTime: "00.00",
  },
};

export const fitPriceView = [
  {
    name: "成本",
    keys: "stockPrice",
  },
  {
    name: "直客",
    keys: "salePrice",
  },
  {
    name: "同业",
    keys: "toBPrice",
  },
  {
    name: "门店",
    keys: "storePrice",
  },
  {
    name: "同事",
    keys: "staffPrice",
  },
];
export function dispose(datas) {
  let obj = {};
  if (JSON.stringify(datas) !== "{}") {
    obj.productId = datas.id;
    obj.productNameCn = datas.productNameCn;
    obj.productNameEn = datas.productNameEn;
    obj.resourceId = datas.rid;
    obj.resourceNameCn = datas.nameCn;
    obj.resourceNameEn = datas.nameEn;
    obj.state = datas.state;
  }
  return obj;
}
//selectPopup 回显处理
export function disposeValue(obj, arr) {
  let resultArr = [];
  arr.forEach((item, index) => {
    if (!isNaN(Number(item))) {
      if (+item < 10) {
        resultArr.push("0" + item);
      } else {
        resultArr.push(item);
      }
    } else if (obj[index].findIndex((n) => n == item) !== -1) {
      let result = obj[index].findIndex((n) => n == item);
      resultArr.push(result);
    } else {
      resultArr.push(0);
    }
  });
  return resultArr;
}
export function disposeYear(yearList, year) {
  let month;
  for (const keys in yearList[year]) {
    if (yearList[year][keys].length != 0) {
      month = yearList[year][keys][0].date;
      return month;
    }
  }
}

export function disposeYearList(that, state, type = "Array") {
  let year = doHandleYear();
  let dateList = yearDataList(year, 2, that);
  let obj = JSON.parse(JSON.stringify(commdityDatas));
  obj.state = state;
  obj.prices.forEach((item) => {
    that.$set(item, "priceUnit", priceUnit[state][0]);
    that.$set(item, "year", dateList);
    if (useTimeList[state]) {
      that.$set(item, "useTime", useTimeList[state]);
    }
  });
  let arr = [];
  arr.push(JSON.parse(JSON.stringify(obj)));
  if (type == "Array") {
    return arr;
  } else {
    return obj;
  }
}
export function pickerCl(datas) {
  if (datas && datas != "") {
    return datas;
  } else {
    return "请选择";
  }
}
//小于10的数组前面加个0
export function numberDs(arr) {
  let result = [];
  for (let i = 0; i < arr; i++) {
    if (i < 10) {
      i = "0" + i;
    } else {
      i = String(i);
    }
    result.push(i);
  }
  return result;
}

export function allDate(obj) {
  let result = [];
  for (const key in obj) {
    for (const key1 in obj[key]) {
      result = [...result, ...obj[key][key1]];
    }
  }
  return result;
}
export function convertToTimeStrings(dateTimeStrings) {
  const timeStrings = [];
  for (const dateTimeString of dateTimeStrings) {
    const dateTime = new Date(dateTimeString);
    const hours = dateTime.getUTCHours().toString().padStart(2, "0");
    const minutes = dateTime.getUTCMinutes().toString().padStart(2, "0");
    const seconds = dateTime.getUTCSeconds().toString().padStart(2, "0");
    const formattedTime = `${hours}:${minutes}:${seconds}`;
    timeStrings.push(formattedTime);
  }
  return timeStrings;
}
export function isDateFormatValid(dateString) {
  const regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
  return regex.test(dateString);
}
//获取当前年月日
export function  getCurrentDate() {
  const currentDate = new Date();

  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const day = String(currentDate.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}